// POSDelivererModal - Modal for assigning a deliverer to a delivery order
import React from "react";
import { Loader2, Truck, User, X, Check } from "lucide-react";

export function POSDelivererModal({ deliverers, assigningDeliverer, onAssign, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b bg-blue-50">
          <div className="flex items-center gap-2">
            <Truck className="w-5 h-5 text-blue-600" />
            <p className="font-bold text-blue-800">Atribuir Estafeta</p>
          </div>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-blue-100">
            <X className="w-5 h-5 text-blue-500" />
          </button>
        </div>
        <div className="p-4">
          <p className="text-sm text-gray-500 mb-3">
            Pedido criado. Selecione um estafeta ou feche para atribuir mais tarde.
          </p>
          {deliverers.length === 0 ? (
            <div className="text-center py-6 text-gray-400">
              <User className="w-10 h-10 mx-auto mb-2 opacity-30" />
              <p className="text-sm">Sem estafetas disponíveis</p>
            </div>
          ) : (
            <div className="space-y-2 max-h-64 overflow-y-auto">
              {deliverers.map(d => (
                <button
                  key={d.id}
                  onClick={() => onAssign(d.id)}
                  disabled={!!assigningDeliverer}
                  className="w-full flex items-center gap-3 p-3 rounded-xl border-2 border-gray-100 hover:border-blue-300 hover:bg-blue-50 transition-all text-left disabled:opacity-60"
                >
                  <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                    {assigningDeliverer === d.id
                      ? <Loader2 className="w-4 h-4 text-blue-500 animate-spin" />
                      : <User className="w-4 h-4 text-blue-500" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-800 truncate">{d.name}</p>
                    {d.phone && <p className="text-xs text-gray-400">{d.phone}</p>}
                  </div>
                  <Check className="w-4 h-4 text-gray-300" />
                </button>
              ))}
            </div>
          )}
          <button
            onClick={onClose}
            className="mt-3 w-full py-2 text-sm text-gray-500 hover:text-gray-700 font-medium"
          >
            Atribuir mais tarde
          </button>
        </div>
      </div>
    </div>
  );
}
